type Fn = () => void | Promise<void>;

interface Options {
  delay?: number; // delay between clicks
  key?: string | number; //opztional key to distinguish different click areas
}

// Registry for click counters and timers
const clickState = new Map<string | number, { count: number; timer?: number }>();

/**
 * Distinguishes between single and double clicks.
 *
 * - if single click → waits for delay to see if a second click comes
 * - when no second click → calls singleFn
 */
export function ifClickOrDblClick(singleFn: Fn, doubleFn: Fn, opts: Options = {}) {
  const delay = opts.delay ?? 250;
  const key = opts.key ?? '__default__';

  const state = clickState.get(key) ?? { count: 0 };
  state.count += 1;
  clickState.set(key, state);

  if (state.timer) window.clearTimeout(state.timer);

  // if second click → instantly call doubleFn
  if (state.count === 2) {
    clickState.delete(key);
    void doubleFn();
    return;
  }

  // if no second click within delay → call singleFn
  state.timer = window.setTimeout(() => {
    clickState.delete(key);
    void singleFn();
  }, delay);
}

/**
 * optional reset (when unmounting components etc.)
 */
ifClickOrDblClick.resetAll = () => {
  for (const [, state] of clickState) {
    if (state.timer) window.clearTimeout(state.timer);
  }
  clickState.clear();
};
